<div class="container">
    <div class="one-item" *ngFor="let item of config;index as i" (click)="onClick($event,item)">
        <a href="#" target="_blank" [title]="item.fileName">{{item.fileName}}</a>
    </div>
</div>